import { useCallback, useState } from 'react';
import { InvitationRecord, InvitationSummary } from './List';
import { retrieveInvite, retrieveInviteSummary } from 'src/pages/admin/services/whitelistService';

const useInvite = () => {
  const [records, setRecords] = useState<InvitationRecord[]>([]);
  const [total, setTotal] = useState(0);
  const [summary, setSummary] = useState<InvitationSummary>()

  const retrieve = useCallback(async (
    page: number,
    pageSize: number,
    search?: string,
    validOnly?: boolean,
    notDistributed?: boolean
  ) => {
    try {
      const response = await retrieveInvite(page, pageSize, search, validOnly, notDistributed);

      setRecords(response.data.items);
      setTotal(response.data.total || 0);
    } catch (error) {
      console.log('error: ', error);
    }
  }, []);

  const retrieveSummary = useCallback(async() => {
    try {
      const response = await retrieveInviteSummary();
      setSummary(response.data)
      
    } catch (error) {
      console.log('error: ', error);
    }

  }, [])

  return {
    retrieve,
    records,
    total,
    retrieveSummary,
    summary
  };
};

export default useInvite;
